/* Veverița Poveștilor — widget chat (vanilla JS).
   Lazy: doar launcher-ul există la load; panoul se construiește la prima deschidere.
   Stochează conversația DOAR în memorie (zero PII, zero persistență).
   build: 2026-07-24b (fix gate consimtamant cookie, anti-deadlock) */
(function () {
  "use strict";

  var cfgEl = document.getElementById("pt-squirrel-config");
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var EN = (CFG.locale || "ro").toLowerCase().indexOf("en") === 0;

  var T = {
    ro: {
      title: "Veverița Poveștilor",
      openChat: "Deschide chat cu Veverița Poveștilor",
      subtitle: "Te ajut să alegi o carte",
      greeting: "Bună! Sunt Veverița Poveștilor. Spune-mi pentru cine cauți o carte (ce vârstă are copilul, ce îi place) și îți găsesc povestea potrivită.",
      disclosure: "Sunt un asistent AI. Nu colectez date personale.",
      privacy: "Confidențialitate",
      placeholder: "Scrie-i veveriței...",
      send: "Trimite",
      close: "Închide",
      viewBook: "Vezi cartea →",
      typing: "Veverița scrie...",
      error: "Hopa, ceva n-a mers.",
      retry: "Reîncearcă",
      recoOne: "1 recomandare.",
      recoMany: "recomandări.",
      nudge: "Te ajut să alegi o carte?",
      consent: "Te rog răspunde mai întâi la preferințele de cookie-uri din pagină, apoi putem sta de vorbă.",
      chips: [
        ["Caut un cadou", "Caut o carte cadou pentru un copil."],
        ["După vârstă", "Vreau o recomandare după vârsta copilului."],
        ["Despre natură", "Caut cărți despre natură și protejarea planetei."],
        ["Emoții și curaj", "Caut o carte despre emoții, curaj și încredere."]
      ]
    },
    en: {
      title: "The Story Squirrel",
      openChat: "Open chat with the Story Squirrel",
      subtitle: "I'll help you pick a book",
      greeting: "Hi! I'm the Story Squirrel. Tell me who you're looking for a book for (the child's age and what they love) and I'll find just the right story.",
      disclosure: "I'm an AI assistant. I don't collect personal data.",
      privacy: "Privacy",
      placeholder: "Write to the squirrel...",
      send: "Send",
      close: "Close",
      viewBook: "View book →",
      typing: "Squirrel is typing...",
      error: "Oops, something went wrong.",
      retry: "Try again",
      recoOne: "1 recommendation.",
      recoMany: "recommendations.",
      nudge: "Need help picking a book?",
      consent: "Please respond to the cookie preferences on the page first, then we can chat.",
      chips: [
        ["A gift", "I'm looking for a gift book for a child."],
        ["By age", "I'd like a recommendation based on the child's age."],
        ["About nature", "I'm looking for books about nature and protecting the planet."],
        ["Feelings & courage", "I'm looking for a book about feelings, courage and confidence."]
      ]
    }
  }[EN ? "en" : "ro"];

  var launcher = document.getElementById("pt-squirrel-launcher");
  if (!launcher) return;

  var state = { built: false, open: false, busy: false, messages: [], els: {}, scrollY: 0 };

  function el(tag, cls, attrs) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (attrs) for (var k in attrs) n.setAttribute(k, attrs[k]);
    return n;
  }

  // ---------- build panel (lazy) ----------
  function build() {
    if (state.built) return;
    state.built = true;

    var backdrop = el("div", "pt-sq pt-sq-backdrop");
    backdrop.addEventListener("click", close);

    var panel = el("div", "pt-sq pt-sq-panel", { role: "dialog", "aria-modal": "true", "aria-label": T.title });

    var handle = el("div", "pt-sq-handle"); handle.appendChild(el("span"));

    var header = el("div", "pt-sq-header");
    var av = el("img", null, { src: CFG.assets.avatar, alt: "", width: "40", height: "40" });
    var htext = el("div", "pt-sq-htext");
    var title = el("div", "pt-sq-title"); title.textContent = T.title;
    var sub = el("div", "pt-sq-subtitle"); sub.textContent = T.subtitle;
    htext.appendChild(title); htext.appendChild(sub);
    var closeBtn = el("button", "pt-sq-close", { type: "button", "aria-label": T.close });
    closeBtn.textContent = "×";
    closeBtn.addEventListener("click", close);
    header.appendChild(av); header.appendChild(htext); header.appendChild(closeBtn);

    var log = el("div", "pt-sq-log", { role: "log", "aria-label": T.title });
    // regiune vizual-ascunsă: anunță O DATĂ răspunsul final (fără spam la streaming)
    var sr = el("div", "pt-sq-sr", { "aria-live": "polite", "aria-atomic": "true" });

    var bar = el("div", "pt-sq-inputbar");
    var input = el("textarea", "pt-sq-input", { rows: "1", placeholder: T.placeholder, "aria-label": T.placeholder, maxlength: "1000" });
    input.addEventListener("input", autogrow);
    input.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); submit(); }
    });
    var send = el("button", "pt-sq-send", { type: "button", "aria-label": T.send });
    send.textContent = "➤";
    send.addEventListener("click", submit);
    bar.appendChild(input); bar.appendChild(send);

    panel.appendChild(handle);
    panel.appendChild(header);
    panel.appendChild(log);
    panel.appendChild(sr);
    panel.appendChild(bar);
    document.body.appendChild(backdrop);
    document.body.appendChild(panel);

    state.els = { backdrop: backdrop, panel: panel, log: log, sr: sr, input: input, send: send };

    panel.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { close(); return; }
      if (e.key === "Tab") trapFocus(e, panel);
    });

    greeting();
  }

  function autogrow() { this.style.height = "auto"; this.style.height = Math.min(this.scrollHeight, 96) + "px"; }

  function trapFocus(e, container) {
    var all = container.querySelectorAll('button, [href], textarea, input, a, [tabindex]:not([tabindex="-1"])');
    var f = Array.prototype.filter.call(all, function (n) { return !n.disabled && n.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  // ---------- scroll lock + tastatura mobilă ----------
  function isMobile() { return window.innerWidth < 768; }

  function lockScroll() {
    state.scrollY = window.scrollY || window.pageYOffset || 0;
    var b = document.body;
    b.style.position = "fixed";
    b.style.top = -state.scrollY + "px";
    b.style.left = "0";
    b.style.right = "0";
    b.style.width = "100%";
  }
  function unlockScroll() {
    var b = document.body;
    b.style.position = ""; b.style.top = ""; b.style.left = ""; b.style.right = ""; b.style.width = "";
    window.scrollTo(0, state.scrollY);
  }

  function adjustVV() {
    if (!state.open || !isMobile() || !window.visualViewport) return;
    var vv = window.visualViewport;
    var kb = Math.max(0, window.innerHeight - vv.height - vv.offsetTop); // înălțime tastatură
    var panel = state.els.panel;
    if (kb > 80) {
      panel.style.bottom = kb + "px";
      panel.style.height = vv.height + "px";
    } else {
      panel.style.bottom = "";
      panel.style.height = "";
    }
  }

  // ---------- open / close ----------
  function open() {
    build();
    if (state.open) return;
    state.open = true;
    dismissNudge();
    if (isMobile()) lockScroll();
    requestAnimationFrame(function () {
      state.els.backdrop.classList.add("is-open");
      state.els.panel.classList.add("is-open");
    });
    launcher.setAttribute("aria-expanded", "true");
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", adjustVV);
      window.visualViewport.addEventListener("scroll", adjustVV);
    }
    setTimeout(function () { state.els.input.focus(); adjustVV(); }, 320);
  }

  function close() {
    if (!state.open) return;
    state.open = false;
    state.els.backdrop.classList.remove("is-open");
    state.els.panel.classList.remove("is-open");
    state.els.panel.style.bottom = ""; state.els.panel.style.height = "";
    launcher.setAttribute("aria-expanded", "false");
    if (window.visualViewport) {
      window.visualViewport.removeEventListener("resize", adjustVV);
      window.visualViewport.removeEventListener("scroll", adjustVV);
    }
    unlockScroll();
    if (launcher.isConnected) launcher.focus();
  }

  // ---------- messages ----------
  function addBubble(role, text) {
    var b = el("div", "pt-sq-msg " + role);
    b.textContent = text || "";
    state.els.log.appendChild(b);
    scrollHard();
    return b;
  }

  function scrollHard() { state.els.log.scrollTop = state.els.log.scrollHeight; }
  function scrollSoft() {
    var l = state.els.log;
    if (l.scrollHeight - l.scrollTop - l.clientHeight < 48) l.scrollTop = l.scrollHeight;
  }
  function announce(msg) { state.els.sr.textContent = ""; state.els.sr.textContent = msg; }

  function greeting() {
    addBubble("bot", T.greeting);
    var disc = el("div", "pt-sq-disclosure");
    disc.appendChild(document.createTextNode(T.disclosure + " "));
    if (CFG.privacyUrl) {
      var a = el("a", "pt-sq-privacy", { href: CFG.privacyUrl, target: "_self" });
      a.textContent = T.privacy;
      disc.appendChild(a);
    }
    state.els.log.appendChild(disc);
    renderChips();
  }

  function renderChips() {
    var wrap = el("div", "pt-sq-chips");
    T.chips.forEach(function (c) {
      var chip = el("button", "pt-sq-chip", { type: "button" });
      chip.textContent = c[0];
      chip.addEventListener("click", function () { wrap.remove(); sendText(c[1]); });
      wrap.appendChild(chip);
    });
    state.els.log.appendChild(wrap);
    scrollHard();
  }

  function submit() {
    var v = state.els.input.value.trim();
    if (!v) return;
    state.els.input.value = "";
    state.els.input.style.height = "auto";
    sendText(v);
  }

  // Nu transmitem nimic transfrontalier (Anthropic, US) cât timp bannerul de
  // consimțământ pentru cookie-uri NU a fost încă onorat. Fail-open la funcțional
  // dacă API-ul Customer Privacy nu e disponibil (chatul rămâne utilizabil).
  function consentBlocked() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.shouldShowBanner !== "function") return false; // API absent -> fail-open
      if (!cp.shouldShowBanner()) return false; // decizia de consimțământ e deja luată -> permite
      // Consimțământ în așteptare. Blocăm DOAR cât timp există un banner real, vizibil,
      // pe care userul îl poate onora. Dacă niciun banner nu e randat (banner dezactivat
      // în admin), NU blocăm chatul: asistentul rulează pe interes legitim, art. 6(1)(f)
      // GDPR (vezi GDPR-CHATBOT-CLAUZA.md), altfel gate-ul intră în deadlock permanent.
      return consentVisible();
    } catch (e) {}
    return false;
  }

  function sendText(text) {
    if (state.busy) return;
    var chips = state.els.log.querySelector(".pt-sq-chips");
    if (chips) chips.remove();
    addBubble("user", text);
    if (consentBlocked()) {
      addBubble("bot", T.consent);
      scrollHard();
      return;
    }
    state.messages.push({ role: "user", content: text });
    stream();
  }

  function setBusy(b) { state.busy = b; state.els.send.disabled = b; }

  function showTyping() {
    var b = el("div", "pt-sq-msg bot");
    var t = el("span", "pt-sq-typing");
    for (var i = 0; i < 3; i++) t.appendChild(el("span"));
    t.setAttribute("aria-label", T.typing);
    b.appendChild(t);
    state.els.log.appendChild(b);
    scrollHard();
    return b;
  }

  async function stream() {
    setBusy(true);
    var typing = showTyping();
    var botBubble = null;
    var acc = "";
    var recoCount = 0;
    try {
      var token = await getTurnstile();
      var res = await fetch(CFG.endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ locale: CFG.locale, messages: state.messages, turnstileToken: token })
      });
      if (!res.ok || !res.body) throw new Error("http");
      var reader = res.body.getReader();
      var dec = new TextDecoder();
      var buf = "";
      while (true) {
        var r = await reader.read();
        if (r.done) break;
        buf += dec.decode(r.value, { stream: true });
        var nl;
        while ((nl = buf.indexOf("\n")) >= 0) {
          var line = buf.slice(0, nl); buf = buf.slice(nl + 1);
          if (line.indexOf("data:") !== 0) continue;
          var payload = line.slice(5).trim();
          if (!payload) continue;
          var ev; try { ev = JSON.parse(payload); } catch (e) { continue; }
          if (ev.type === "text") {
            if (typing) { typing.remove(); typing = null; }
            if (!botBubble) botBubble = addBubble("bot", "");
            acc += ev.text;
            botBubble.textContent = acc;
            scrollSoft();
          } else if (ev.type === "products") {
            if (typing) { typing.remove(); typing = null; }
            recoCount += (ev.items || []).length;
            renderCards(ev.items);
          } else if (ev.type === "error") {
            throw new Error("stream");
          }
        }
      }
      if (typing) typing.remove();
      if (acc) state.messages.push({ role: "assistant", content: acc });
      // anunță O DATĂ pentru cititoarele de ecran (text final + nr. recomandări)
      var note = recoCount === 1 ? T.recoOne : recoCount > 1 ? recoCount + " " + T.recoMany : "";
      announce((acc + " " + note).trim());
    } catch (e) {
      if (typing) typing.remove();
      showError();
    } finally {
      setBusy(false);
    }
  }

  function showError() {
    var err = el("div", "pt-sq-error");
    err.appendChild(document.createTextNode(T.error + " "));
    var btn = el("button", "pt-sq-retry", { type: "button" });
    btn.textContent = T.retry;
    btn.addEventListener("click", function () { err.remove(); stream(); });
    err.appendChild(btn);
    state.els.log.appendChild(err);
    scrollHard();
    announce(T.error);
  }

  function renderCards(items) {
    (items || []).forEach(function (p) {
      var card = el("a", "pt-sq-card", { href: p.url, target: "_self" });
      if (p.cover) {
        var img = el("img", null, { src: p.cover, alt: "", loading: "lazy", width: "60", height: "60" });
        card.appendChild(img);
      }
      var body = el("div", "pt-sq-cbody");
      var t = el("div", "pt-sq-ctitle"); t.textContent = p.title;
      var meta = el("div", "pt-sq-cmeta");
      meta.textContent = [p.age, p.theme].filter(Boolean).join(" · ");
      var price = el("div", "pt-sq-cprice");
      price.textContent = formatPrice(p.price);
      body.appendChild(t); body.appendChild(meta); body.appendChild(price);
      var cta = el("span", "pt-sq-cta"); cta.textContent = T.viewBook;
      card.appendChild(body); card.appendChild(cta);
      state.els.log.appendChild(card);
    });
    scrollSoft();
  }

  function formatPrice(amount) { return Math.round(Number(amount)) + " lei"; }

  // ---------- Turnstile (opțional) ----------
  function getTurnstile() {
    return new Promise(function (resolve) {
      if (!CFG.turnstileSitekey) { resolve(""); return; }
      function run() {
        try {
          window.turnstile.ready(function () {
            window.turnstile.render(ensureTsHost(), {
              sitekey: CFG.turnstileSitekey, size: "invisible",
              callback: function (tok) { resolve(tok); },
              "error-callback": function () { resolve(""); }
            });
            window.turnstile.execute(ensureTsHost());
          });
        } catch (e) { resolve(""); }
      }
      if (window.turnstile) { run(); return; }
      var s = document.createElement("script");
      s.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
      s.async = true; s.defer = true; s.onload = run; s.onerror = function () { resolve(""); };
      document.head.appendChild(s);
    });
  }
  function ensureTsHost() {
    var h = document.getElementById("pt-sq-ts");
    if (!h) { h = el("div", null, { id: "pt-sq-ts", style: "display:none" }); document.body.appendChild(h); }
    return h;
  }

  // ---------- nudge (unic / sesiune) ----------
  function consentVisible() {
    var sels = ['[role="alertdialog"]', '#shopify-pc__banner', '.shopify-pc__banner', '[class*="consent" i]', '[id*="consent" i]', '[class*="cookie" i]'];
    for (var i = 0; i < sels.length; i++) {
      try {
        var n = document.querySelector(sels[i]);
        if (n && n.offsetParent !== null) return true;
      } catch (e) {}
    }
    return false;
  }

  function maybeNudge() {
    var ptype = CFG.pageType || "";
    if (ptype !== "product" && ptype !== "collection") return;
    try { if (sessionStorage.getItem("pt_sq_nudged")) return; } catch (e) {}
    setTimeout(function () {
      if (state.open) return;
      try { if (sessionStorage.getItem("pt_sq_nudged")) return; } catch (e) {}
      if (consentVisible()) return; // nu acoperi bannerul de consimțământ
      var n = el("div", "pt-sq pt-sq-nudge");
      var openBtn = el("button", "pt-sq-nudge-open", { type: "button" });
      openBtn.textContent = T.nudge;
      openBtn.addEventListener("click", open);
      var x = el("button", "pt-sq-nudge-x", { type: "button", "aria-label": T.close });
      x.textContent = "×";
      x.addEventListener("click", function (e) { e.stopPropagation(); dismissNudge(); });
      n.appendChild(openBtn); n.appendChild(x);
      document.body.appendChild(n);
      state.nudgeEl = n;
      try { sessionStorage.setItem("pt_sq_nudged", "1"); } catch (e) {}
    }, 35000);
  }
  function dismissNudge() {
    if (state.nudgeEl) { state.nudgeEl.remove(); state.nudgeEl = null; }
    try { sessionStorage.setItem("pt_sq_nudged", "1"); } catch (e) {}
  }

  // ---------- evită CTA-urile de cumpărare ----------
  // Bara sticky „Adaugă în coș" (PDP mobil) și cart drawerul deschis au prioritate:
  // launcherul urcă deasupra barei, respectiv dispare cât timp drawerul e deschis
  // (acoperea butonul de plată expres). Failure-safe: fără JS rămâne comportamentul vechi.
  function watchPurchaseUI() {
    var bar = document.querySelector(".sticky-add-to-cart__bar");
    if (bar) {
      var syncLift = function () {
        // bara e position:fixed => offsetParent e mereu null; folosim computed style
        // (pe desktop brand.css o ascunde cu display:none la min-width 750px)
        var cs = window.getComputedStyle(bar);
        var on = bar.getAttribute("data-stuck") === "true" && cs.display !== "none" && cs.visibility !== "hidden";
        document.body.classList.toggle("pt-sq-avoid-sticky", on);
      };
      try {
        new MutationObserver(syncLift).observe(bar, { attributes: true, attributeFilter: ["data-stuck"] });
        window.addEventListener("resize", syncLift, { passive: true });
        syncLift();
      } catch (e) {}
    }
    var drawer = document.querySelector("#cart-drawer dialog");
    if (drawer) {
      var syncDrawer = function () {
        document.body.classList.toggle("pt-sq-cart-open", drawer.hasAttribute("open"));
      };
      try {
        new MutationObserver(syncDrawer).observe(drawer, { attributes: true, attributeFilter: ["open"] });
        syncDrawer();
      } catch (e) {}
    }
  }

  // ---------- wire ----------
  launcher.setAttribute("aria-label", T.openChat);
  launcher.addEventListener("click", function () { state.open ? close() : open(); });
  watchPurchaseUI();
  maybeNudge();
})();
